import { costTrackerFields } from 'src/enums/cost-tracker';
import { getColumnAlignments } from 'src/common/table/column-utils';
import { getFields } from './get-ct-fields';

const columnAlignment: Partial<Record<costTrackerFields, 'left' | 'right'>> = {
  [costTrackerFields.NAME]: 'left',
  [costTrackerFields.START]: 'left',
  [costTrackerFields.COST_AFE]: 'right',
  [costTrackerFields.COST_SUGGESTED]: 'right',
  [costTrackerFields.COST_ACTUAL]: 'right',
  [costTrackerFields.VARIANCE]: 'right',
};

export const getColumnAlignment = (disabledFields: string[]) => {
  const fields = getFields(disabledFields);
  return getColumnAlignments(fields, columnAlignment);
};
